import React, { Component } from "react";
import "./mechanismViewer.css";
import axios from "../../api/axios.js";
import { useState } from "react";
import { useEffect } from "react";
import SmallLoading from "../smallLoading.js";
import StatsBox from "../StatsPage/StatsBox.js";
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  MarkerType 
} from '@xyflow/react';
import MoleculeNode from "./moleculeNode.js";
import MoleculeNodeLR from "./moleculeNodeLR.js";
import ReactionEdge from "./reactionEdge.js";
import DownloadImageButton from "./downloadImageButton.js";
import Dagre from '@dagrejs/dagre';
 
import '@xyflow/react/dist/style.css';


const nodeTypes = { moleculeNode: MoleculeNode };
const nodeTypeLR = { moleculeNode: MoleculeNodeLR };
const edgeTypes = { reactionEdge: ReactionEdge };

function MechanismViewer({searchData, height="500px", orientation = "TD"}) {
  const [isLoading, setIsLoading] = useState(true);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);


  async function loadGraph() {
    console.log("loadGraph called with searchData:", searchData);
    const getLayoutedElements = (nodes, edges, options) => {
      const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
      g.setGraph({ rankdir: options.direction });
 
      edges.forEach((edge) => g.setEdge(edge.source, edge.target));
      nodes.forEach((node) =>
        g.setNode(node.id, {
          ...node,
          width: orientation === "LR" ? 300 : 200,
          // Taller than the bare image+name+copy node: each node now also
          // carries the evidence-badge row, so dagre needs the extra height to
          // keep ranks from crowding/overlapping.
          height: 250,
        }),
      );
 
      Dagre.layout(g);
 
      return {
        nodes: nodes.map((node) => {
          const position = g.node(node.id);
          let x = position.x - (190) / 2;
          let y = position.y - (200) / 2;
          if (orientation == "LR") {
            y = position.y - (400) / 2; 
            x= position.x - (400) / 2; 
          }
          return { ...node, position: { x, y } };
        }),
        edges,
      };
    };
    
    const data = await axios.post("/getMechNet", searchData);
    let graph = data.data.data.res_graph;

    const layouted = getLayoutedElements(graph.nodes, graph.edges, { direction: orientation });
      let ed = layouted.edges.map(edge => ({
        ...edge,
        markerEnd: {
            type: MarkerType.Arrow, width: 15, height: 15}, style: {strokeWidth: 2}
      }));
      setNodes([...layouted.nodes]);
      setEdges([...ed]);

      setIsLoading(false);
    }

    useEffect(() => {
      setIsLoading(true);
        loadGraph();
      }, []);

    useEffect(() => {
      console.log("searchData changed, reloading graph", searchData);
      setIsLoading(true);
      loadGraph();
}, [searchData]);

    if (isLoading) {
      return(
        <StatsBox title={"Loading tree..."}>
          <SmallLoading />
          </StatsBox>) 
    }
    
    
    const nodeColor = (node) => {
        if (node.data.highlight) {
            return node.data.highlight;
        }
        return '#e2e2e2';
    }

    const currentNodeTypes = orientation === "LR" ? nodeTypeLR : nodeTypes;


    return (
      <>
      <div style={{ width: '100%', height: height, border: '1px solid black' }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          nodesConnectable={false}
          onEdgesChange={onEdgesChange}
          nodeTypes={currentNodeTypes}
          edgeTypes={edgeTypes}
          maxZoom={2}
          minZoom={0.001}
          fitView
        >
          <Controls />
          <DownloadImageButton />
        </ReactFlow>
      </div>
      </>
    );

//<MiniMap nodeColor={nodeColor} zoomable pannable />

}

export default MechanismViewer;